export const RouterPaths = {
  home: '',
  settings: 'settings',
  support: 'support',
  termsAndConditions: 'terms-and-conditions',
};
